/** 인증 안내 문구. */


export enum AUTH_MESSAGES {
  NOT_AUTH = "권한이 없습니다.",
  NOT_FOUND = "로그인이 필요합니다.",
  INACTIVE_ACCOUNT = "비활성화된 계정입니다.",
}
